<mat-toolbar class="header__toolbar mat-accent" *ngIf="!hideLanguage">
  <div class="wrapper">
    <div class="wrapper__content" fxLayoutAlign="start center">
      <img class="toolbar__logo" src="assets/img/img_scf_logo.svg" alt="Logo SABADELL" />
      <div class="vertical__bar"></div>
      <div fxLayout="column" class="toolbar__title">
        <img src="assets/img/img_global-credit-WHITE.svg" alt="Logo seleccionar idioma" />
      </div>
      <div fxLayout="column" class="toolbar_selector">
        <app-language-selector class="toolbar__button__language" icon="true"></app-language-selector>
      </div>
    </div>
  </div>
</mat-toolbar>

<mat-toolbar class="header__toolbar noLanguage" *ngIf="hideLanguage">
  <div class="wrapper">
    <div class="wrapper__content" fxLayoutAlign="start center">
      <img class="toolbar__logo" src="assets/img/sabadell_logo_not_background.png" alt="Logo SABADELL" />
      <div *ngIf="onfido" fxLayout="column" class="toolbar_selector">
        <button id="supportButtonHeader" class="support-phone-button">
          <mat-icon color="accent" class="support-icon icon-ic_help"></mat-icon>
          <div class="support-text">
            <div class="question">{{ 'videoselfing.text' | translate }}</div>
            <div class="phone-number">{{ 'videoselfing.phone' | translate }}</div>
          </div>
        </button>
      </div>
    </div>
  </div>
</mat-toolbar>
